<template>
<div class="title-bar-container">
  <rich-card class="title-bar">
    <header slot="header" class="title-bar-wrap">
      <div class="locate-err-tips" v-if="locateErr">
        <i class="icon-lingdang"></i>
        {{gettext('当前定位失败')}}
      </div>
      <i class="title-bar-back fusion-r_fusion_icon_back_ios" v-if="(needBack || showBack) && !cancelText" @click="goBack"></i>
      <h2 class="title-bar-main">{{ title }}</h2>
      <h2 class="title-bar-action" v-if="actionText" @click="actionHandler">
        {{actionText}}
      </h2>
      <h2 class="title-bar-cancel" v-if="cancelText" @click="cancelHandler">
        {{cancelText}}
      </h2>
    </header>
  </rich-card>
</div>
</template>

<script>

export default {
  name: 'title-bar',
  props: {
    title: {
      type: String,
      required: true
    },
    showBack: {
      type: Boolean,
      required: false,
      default: false
    },
    needBack: {
      type: Boolean,
      required: false,
      default: false
    },
    // 判断是否跳回HOME页
    backHome: {
      type: Boolean,
      required: false,
      default: false
    },
    locateErr: {
      type: Boolean,
      required: false,
      default: false
    },
    actionText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    action: {
      type: Function,
      default: () => {}
    },
    cancel: {
      type: Function,
      default: () => {}
    },
    useNative: {
      type: Boolean,
      default: false
    }
  },
  methods: {

    async goBack () {
      this.$emit('back')
      if (this.needBack) {
        this.$router.back({
          useNative: this.useNative
        })
      }
    },
    actionHandler () {
      this.action()
    },
    cancelHandler () {
      this.cancel()
    }
  }
}
</script>
<style lang="scss">
.title-bar-container{
  padding-top: var(--barheight);
  background-color: #fff;
}
.title-bar {
  position: relative;
  height: 100px;
  background: $color-white;
  &-wrap {
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &-main {
    font-size: $fontsize-large;
    line-height: 1.5;
  }
  &-action {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    font-size: $fontsize-large;
    color: $color-orange;
    padding: 20px;
    background-color: #FFF;
  }
  &-cancel {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    font-size: $fontsize-large;
    color: $color-grey;
    padding: 20px;
    background-color: #FFF;
  }
  .locate-err-tips {
    position: fixed;
    top: 26px;
    right: 0;
    display: inline-block;
    padding: 10px;
    padding-right: 30px;
    color: $color-white;
    font-size: $fontsize-small;
    background: $color-light-red;
  }
  &-back {
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translateY(-50%);
    font-size: 36px;
    padding: 20px;
  }
}
</style>
